module.exports = __webpack_public_path__ + "assets/img/img_cooperation3.e807f623.png";